import React, { useState, useEffect } from 'react';
import { StoreItem } from '../StoreItem';
import styles from './StoreItemsList.module.scss';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import IconChat from '../../../assets/icons/store/icon_chat.png';
import closeIcon from '../../../assets/icons/btn-close-X.svg';

const STORE_ITEMS_IMAGE_URL = process.env.REACT_APP_STORE_GOOGLE_STORAGE_BASE_URL;

const StoreItemsList = ({ itemList, itemsPerPage, submitAction }) => {
    const [list, setList] = useState([]);
    const [paginatedList, setPaginatedList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const {t} = useTranslation();
    const [showFAQ, setShowFAQ] = useState(false);
    const [showVIPInfo, setShowVIPInfo] = useState(false);

    useEffect(() => {
        setList(itemList);
    }, [itemList])

    useEffect(() => {
        let totalItems = list.length;
        if (totalItems > 0) {
            setCurrentPage(1);
        }
        setTotalPages(Math.ceil(totalItems / itemsPerPage));
        let paginatedData = list.slice(0, itemsPerPage);
        setPaginatedList(paginatedData);
    }, [list])

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            let initialItem = (pageNumber - 1) * itemsPerPage;
            let finalItem = pageNumber * itemsPerPage;

            let paginatedData = list.slice(
                initialItem,
                finalItem
            );
            setPaginatedList(paginatedData);
            setCurrentPage(pageNumber);
        }
    };

    const displayVIPInfoModal = () => {
        setShowFAQ(false);
        setShowVIPInfo(true);
    }

    const displayFAQModal = () => {
        setShowVIPInfo(false);
        setShowFAQ(true);
    }

    return (
        <div className={styles.store_items_list}>
            <div className={styles.items_container}>
                {paginatedList.length > 0 && paginatedList.map((item, index) => (
                    <React.Fragment key={index} >
                        <StoreItem
                            name={item.item_name}
                            category={item.category}
                            salesCategory={item.sales_category}
                            salesLimit={item.sales_limit}
                            isBuyable={item.isBuyable}
                            buyablePeriodTimeout={item.buyablePeriodTimeout}
                            image={STORE_ITEMS_IMAGE_URL + item.item_id + '.png'}
                            description={item.description}
                            price={item.price}
                            vipPoints={item.vip_points}
                            stat1={item.stat_1}
                            stat2={item.stat_2}
                            discountPercent={item.discount_percent}
                            specialDiscountPercent={item.special_discount_percent}
                            originalPrice={item.originalPrice}
                            itemId={item.item_id}
                            itemPeriodFrom={item.item_period_from}
                            itemPeriodTo={item.item_period_to}
                            itemStockCount={(item?.sales_limit - item?.counter) || 0}
                            submitAction={submitAction}
                        />
                    </React.Fragment>
                ))}
            </div>

            <div className={styles.faq_wrapper}>
                <div className={styles.faq} onClick={displayFAQModal}>
                    <div className={styles.icon_chat}>
                        <img src={IconChat} alt="Icon Chat" />
                    </div>
                    <div className={styles.faq_text}>
                        <span>{t('FAQ')}</span>
                    </div>
                </div>

                <div className={styles.faq} onClick={displayVIPInfoModal}>
                    <div className={styles.icon_chat}>
                        <img src={IconChat} alt="Icon Chat" />
                    </div>
                    <div className={styles.faq_text}>
                        <span>{t('ABOUT_HERO_POINTS')}</span>
                    </div>
                </div>
            </div>

            { (totalPages > 1)
            ? 
            <div className={styles.pagination}>
                <div
                    className={`${styles.arrow_btn} ${styles.left}`}
                    onClick={() =>
                        handlePageChange(currentPage - 1)
                    }
                ></div>
                <div className={styles.page_number_container}>
                    {currentPage > 2 && (
                        <>
                            <div
                                className={styles.page_btn}
                                onClick={() =>
                                    handlePageChange(1)
                                }
                            >
                                1
                            </div>
                            <div className={styles.page_dots}>
                                ...
                            </div>
                        </>
                    )}

                    {currentPage - 1 > 0 && (
                        <div className={styles.page_btn} onClick={() => handlePageChange(currentPage - 1)}>
                            {currentPage - 1}
                        </div>
                    )}
                    <div className={`${styles.page_btn} ${styles.current_page}`}>
                        {currentPage}
                    </div>
                    {currentPage + 1 <= totalPages && (
                        <div className={styles.page_btn} onClick={() => handlePageChange(currentPage + 1)}>
                            {currentPage + 1}
                        </div>
                    )}

                    {currentPage < totalPages - 1 && (
                        <>
                            <div className={styles.page_dots}>
                                ...
                            </div>
                            <div
                                className={styles.page_btn}
                                onClick={() =>
                                    handlePageChange(totalPages)
                                }
                            >
                                {totalPages}
                            </div>
                        </>
                    )}
                </div>
                <div
                    className={`${styles.arrow_btn} ${styles.right}`}
                    onClick={() =>
                        handlePageChange(currentPage + 1)
                    }
                ></div>
            </div>
            : <></> }

            <Modal show={showFAQ || showVIPInfo} className={styles.faq_vip_modal} contentClassName={styles.faq_vip_modalContent} dialogClassName={styles.faq_vip_modalDialog} onHide={() => { setShowFAQ(false); setShowVIPInfo(false)}} centered>
                <button className={styles.close_btn} onClick={() => {setShowFAQ(false); setShowVIPInfo(false)}}>
                    <img src={closeIcon} alt="close" />
                </button>
                <Modal.Body bsPrefix={styles.faq_vip_modalBody}>
                    {showFAQ ?
                        <>
                            <div className={styles.faq_vip_modal_title}>{t('FAQ')}</div>
                            <div className={styles.faq_vip_modal_description}>{t('FAQ_DESCRIPTION')}</div>
                            <div className={styles.faq_vip_link}>
                                { t('FAQ_PLEASE_LINK') }
                                <a href="https://medium.com/tower-token/introducing-the-tower-token-web-store-43e7012a1fd0" target="_blank" rel="noopener noreferrer">
                                    {t('TOWER_MEDIUM')}
                                </a>
                            </div>
                        </> : ''
                    }

                    {showVIPInfo ?
                        <>
                            <div className={styles.faq_vip_modal_title}>{t('ABOUT_TOWER_HERO_POINTS')}</div>
                            <div className={styles.faq_vip_modal_description}>{t('ABOUT_TOWER_HERO_POINTS_DESCRIPTION')}</div>
                            <div className={styles.faq_vip_link}>{t('VIP_POINTS_CONVERSION_RATE')}</div>
                            <div className={styles.faq_vip_link}>
                                { t('TO_LEARN_MORE_PLEASE_VISIT') }&nbsp;
                                <a href="https://medium.com/tower-token/introducing-the-tower-token-web-store-43e7012a1fd0" target="_blank" rel="noopener noreferrer">
                                    {t('TOWER_MEDIUM')}
                                </a>
                            </div>
                        </> : ''
                    }
                </Modal.Body>
            </Modal>
   
        </div>
    )
}

export { StoreItemsList }
